import React from 'react';
import { useParams } from 'react-router-dom';
import Tabs_nav from "../../app_structure/tabs_nav/tabs_home.jsx";
import Orders from "../../order/orders/orders.jsx";
import HistoryHome from "./history/accept_home.jsx";
import Options from "../../shop/ai/options.jsx";
import Home_list from "../../kiemtien/urlshorten/vuotlink/client/home_list.jsx";

const Mmo_check_home = () => {
    const { slug_1, slug_2, slug_3, slug_4 } = useParams();

    return (
        <>

            <Tabs_nav
                category={'mmo_p2p_shop'}
                slug_1={slug_1}
                slug_2={slug_2}
                slug_3={slug_3}
                slug_4={slug_4}
            />
            {/* <div className="mt-6 text-center">
                <div className="text-3xl font-extrabold tracking-wide text-gray-800">
                    Updating
                </div>
            </div> */}
            {slug_2 == 'history' && (
                <HistoryHome slug_3={slug_3} slug_4={slug_4} />
            )}
            {slug_2 == 'main' && (
                <Options category="p2p_mmo_main" />
            )}
            {(slug_2 == 'orders' && slug_3 == 'home' ) && (
                <Options category="p2p_mmo_orders" />
            )}
            {(slug_2 == 'orders' && slug_3 == 'vip' ) && (
                <Orders category_main='p2p_mmo' />
            )}
            {slug_2 == 'cilent' && (
                <Home_list category={slug_3} />)}
        </>
    );
};

export default Mmo_check_home;
